import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LoginResponse } from 'Types/App/auth';
import jscookie from 'js-cookie';
import jwt_decode from 'jwt-decode';
import dayjs from 'dayjs';
import { DATE_FORMAT_1 } from 'Constant/Date';

const initialState: LoginResponse = {
  accessToken: null,
  name: null,
  role: null,
  phone: null,
  email: null,
};

interface TokenInfo {
  email: string;
  exp: number;
  iat: number;
  id: number;
  name: string;
}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, data: PayloadAction<LoginResponse>) => {
      const payload = data.payload;
      state.accessToken = payload.accessToken;
      state.name = payload.name;
      state.role = payload.role;
      state.email = payload.email;
      state.phone = payload.phone;
      if (payload.accessToken) {
        const decoded: TokenInfo = jwt_decode(`${payload.accessToken}`);
        const dateNow = new Date().toJSON().slice(0, 10).replace(/-/g, '-');
        const dateDuration = dayjs.unix(decoded?.exp || 0).format(DATE_FORMAT_1);
        jscookie.set('token', payload.accessToken, {
          expires: Math.floor((Date.parse(dateDuration) - Date.parse(dateNow)) / 86400000),
        });
      }
    },
    logout: (state) => {
      state = { ...initialState };
      jscookie.remove('token');
      return state;
    },
  },
});

export const { login, logout } = authSlice.actions;
export default authSlice.reducer;
